import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { UseCases } from '../components/UseCases';
import { WhyMatters } from '../components/WhyMatters';
import { Partnership } from '../components/Partnership';
import { DemoTour } from '../components/DemoTour';
import { FinalCTA } from '../components/FinalCTA';
export function Home() {
  return <main data-id="element-235" data-mp="29gd9waz4fq68">
      <Hero data-id="element-236" data-mp="29flofsz8n8to" />
      <About data-id="element-237" data-mp="29f282gp8kshr" />
      <Problem data-id="element-238" data-mp="29fbwhzumurlc" />
      <Solution data-id="element-239" data-mp="29etv6ot45n6k" />
      <Services data-id="element-240" data-mp="29ihp3p2h0blt" />
      <HowItWorks data-id="element-241" data-mp="2dhgt97gdo4c7" />
      <UseCases data-id="element-242" data-mp="2dhyu6hdzj6qg" />
      <WhyMatters data-id="element-243" data-mp="2dii1z59x8eqr" />
      <Partnership data-id="element-244" data-mp="2dj1n0uuvbj90" />
      <DemoTour data-id="element-245" data-mp="2dfdu9xx8z0vc" />
      <FinalCTA data-id="element-246" data-mp="3kvk3qel0er3c" />
    </main>;
}